import { getUriParameterBoolean } from '@sas-dvr/ltjs-commons/ltjsUtil';
import { setFeatureFlagOverride } from '../components/FeatureFlagOverrideProvider';

export const modernThemeEnabled = getUriParameterBoolean('VASDK_THEME_MODERNIZATION', false);
if (modernThemeEnabled) {
  setFeatureFlagOverride('NOVACOMMONS-22288_ThemeModernization_NewTokenValues', true);
}
